<template>
  <div @mouseover="isDropdownActive = true" @mouseleave="isDropdownActive = false">
    <router-link class="nav-link no-underline" :to="categoryLink(item)">
      <div class="nav-link-content">
        <span class="nav-link-content-title"> {{ item.name }} </span>
      </div>
      <img src="../../../../../assets/shop/nav-arrow.svg"
           class="nav-link-arrow"
           :class="{ 'is-hidden': !item.children_count }"
           alt="arrow"
           width="8"
           height="13"
           loading="eager"
           fetchpriority="high"
      >
    </router-link>
    <dropdown-block ref="dropdown"
                    v-if="item.children_count && isDropdownActive"
                    :list="item.children_data"
                    :list-naming="item.name"
    />
  </div>
</template>

<script>
import { formatCategoryLink } from '@vue-storefront/core/modules/url/helpers'
import { mapGetters } from 'vuex'
import DropdownBlock from 'theme/components/core/blocks/Shop/Navigation/Dropdown/DropdownBlock'

export default {
  name: 'CategoryNavLink',
  components: {
    DropdownBlock
  },
  props: {
    item: {
      type: Object
    }
  },
  data () {
    return {
      isDropdownActive: false
    }
  },
  computed: {
    ...mapGetters({
      currentPartner: 'partners/getCurrentPartner'
    }),
    currentPartnerCode () {
      return this.currentPartner.code
    },
    currentLocationCode () {
      return this.$route.params.locationCode
    }
  },
  methods: {
    categoryLink (category) {
      return `/${this.currentLocationCode}/${this.currentPartnerCode}${formatCategoryLink(category)}`
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-link {
  padding: 10px 0 10px 20px;

  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  transition: .2s;

  &:hover {
    cursor: pointer;
    background: #fff;
  }

  &-content {
    display: flex;
    align-items: center;

    &-image {
      width: 20px;
      height: 20px;

      padding-right: 10px;
      //filter: invert(69%) sepia(89%) saturate(1375%) hue-rotate(344deg) brightness(102%) contrast(92%);
    }

    &-title {
      color: #111;
      font-size: 14px;
      font-weight: 600;
    }
  }

  &-arrow {
    padding: 0 20px;

    width: 10px;
    height: 14px;

    &.is-hidden {
      width: 0;
      height: 0;
    }
  }
}
</style>
